import Vue from 'vue';
import i18n from '@/i18n';
const vue = new Vue({i18n});

export const ACTIVE = "ACTIVE";
export const CANCELED = "CANCELED";
export const FINISHED = "FINISHED";

export const STATUS_PROTOCOL = [
    {id: ACTIVE, name: vue.$t('enumerations.status-protocol.active')},
    {id: CANCELED, name: vue.$t('enumerations.status-protocol.canceled')},
    {id: FINISHED, name: vue.$t('enumerations.status-protocol.finished')},
];

export const _getStatusProtocolLabel = (statusProtocol) => {
    switch (statusProtocol) {
        case ACTIVE : return vue.$t('enumerations.status-protocol.active');
        case CANCELED : return vue.$t('enumerations.status-protocol.canceled');
        case FINISHED : return vue.$t('enumerations.status-protocol.finished');
    }
}